import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PermissionGroupMapping = React.lazy(() =>
    import('../PermissionGroupMapping')
);
const permissionGroupMappingRoutesRegistry = [
    {
        path: PAGE_URL.PERMISSION_GROUP_MAPPING_PAGE,
        element: <PermissionGroupMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default permissionGroupMappingRoutesRegistry;
